import React from 'react'
import { Tabs as BootstrapTabs } from 'react-bootstrap'
import { TabsProps } from 'react-bootstrap/Tabs'
import './Tabs.scss'

export const Tabs: React.FC<TabsProps> = ({ className, children, mountOnEnter = true, ...rest }) => {
  return (
    <BootstrapTabs className={`${className} d-flex zocks-gap-2 zocks-tabs`} variant='underline' mountOnEnter={mountOnEnter} {...rest}>
      {children}
    </BootstrapTabs>
  )
}
